.studentCell {
  width: 25%;
}
.institutionCell {
  width: 25%;
}
.contactCell {
  width: 15%;
}
.statusCell {
  width: 15%;
}
.buttonCell {
  width: 20%;
}
